import {SET_USER_DATA} from '../costants/ActionTypes'

const initialState = {
  is_auth: false,
  fio: "",
  email: "",
  phone:"",
  discount:"",
  adress:"",
  confirm_rules: false,
  comment: "",
}

const nuser = (state = initialState, action) => {

  switch (action.type) {

    case SET_USER_DATA:
      return Object.assign({}, state, action.data);

    default:
      return state
  }

}

export default nuser;